export function getTitleByUrl(url, constObj) {
    for (const key in constObj) {
        if (constObj[key].url === url) {
            return constObj[key].title;
        }
    }
    return null;
}

export const isEnglish = (str) => /^[a-zA-Z_0-9\s]+$/.test(str);
